import React, { useState, useEffect } from 'react';

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import ReceiptIcon from '@material-ui/icons/Receipt';

import PhotoCamera from '@material-ui/icons/PhotoCamera';

import IconButton from "@material-ui/core/IconButton";
import useAuth from "hooks/useAuth";

import Tooltip from "@material-ui/core/Tooltip";

import { makeStyles } from "@material-ui/core/styles";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDate } from "services/formatDate.js";
import Camera from 'components/Camera/Camera'

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },   
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    floatRight: {
        float: "right",
        marginRight: "56px"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableDeliveryman({ sell, loadTotal, loadSell }) {

    const classes = useStyles();
    const classes2 = useStyles2();
    const [modalShow, setModalShow] = useState(false);
    const [index, setIndex] = useState(sell[0] ? sell[0] : { id: 1 });
    const [totalPrice2, setTotalPrice2] = useState(0);
    const [totalResult, setTotalResult] = useState(0);
    const [percentage, setPercentage] = useState(0);

    function callModal(index) {
        setIndex(index);
        setModalShow(true);
    }

   
    async function openReceipt(sell) {
        let link2 = "https://dsaprospectos.com.br:8882/image/"+sell[0].nf;
        if (sell[0].receipt) {
         //   window.open(link, "_blank")
        } else {
            window.open(link2, "_blank")
        }
    }


    function totalPrice(index) {
        let total = 0;
        let result = 0;
        for (let i = 0; i < index.length; i++) {
            total = parseFloat(total) + parseFloat(index[i].price_total);
            result = parseFloat(result) + parseFloat(index[i].result_operation);
        }
        setTotalPrice2(total)
        setTotalResult(result)
        setPercentage(result / total * 100);
    }

    function getNf() {
        let teste = [];
        for (let i = 0; i < sell.length; i++) {
            teste[i] = [];
            teste[i].push(sell[i].nf)
            teste[i].push(sell[i].fantasy_name)
            teste[i].push(sell[i].amount)
            teste[i].push((sell[i].amount / sell[i].box))
            teste[i].push(sell[i].name)
            teste[i].push("R$" + sell[i].price)
            teste[i].push("R$" + sell[i].practice_price)
            teste[i].push("R$" + sell[i].discount)
            teste[i].push("R$" + sell[i].price_total)
            teste[i].push(formatDate(sell[i].date_of_sell))
            teste[i].push(
                <CardIcon>
                    <Icon title={sell[i].validated ? "Validado" : "Não validado"}>{sell[i].validated ? "done" : "clear"}</Icon>
                </CardIcon>
            )
            teste[i].push(
                sell[i].date_of_delivery ? formatDate(sell[i].date_of_delivery) : "Não entregue"
            )
            teste[i].push(
                sell[i].deliverymanname ? sell[i].deliverymanname : "Não entregue"
            )
        }
        return teste;
    }

    useEffect(() => {
        totalPrice(sell);
    }, [sell])

    return (
        <GridItem xs={12} sm={12} md={12}>
            {sell[0] !== undefined ? (
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.zindex} color={sell[0].remove_in_hands ? "primary" : (sell[0].validated ? "success" : "danger")}>
                            <h4 className={classes.cardTitleWhite}>
                                {!sell[0].validated ?
                                    <Tooltip
                                        id="tooltip-top"
                                        title={"Recibo"}
                                        placement="top"
                                        classes={{ tooltip: classes2.tooltip }}
                                    >
                                        <IconButton
                                            aria-label="Done"
                                            className={classes2.tableActionButton}
                                            onClick={() => callModal(sell)}
                                        >
                                            <PhotoCamera
                                                className={
                                                    classes2.tableActionButtonIcon + " " + classes2.edit2
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    : <Tooltip
                                    id="tooltip-top"
                                    title={"Recibo"}
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Done"
                                        className={classes2.tableActionButton}
                                        onClick={() => openReceipt(sell)}
                                    >
                                        <ReceiptIcon
                                            className={
                                                classes2.tableActionButtonIcon + " " + classes2.edit2
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>}
                                Vendas - {sell[0].social_reason} - {sell[0].nf}<b className={classes.floatRight}> Total: R$ {totalPrice2.toFixed(2)} Resultado: R$ {totalResult.toFixed(2)} - {percentage.toFixed(2)}%</b></h4>
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="danger"
                                index={index}
                                tableHead={["Nota Fiscal", "Fantasia", "Quantidade", "Quantidade em caixa", "Produto", "Preço", "Preço praticado", "Desconto", "Preço total", "Data da venda", "Status", "Data da entrega", "Entregador"]}
                                tableData={getNf()}
                            />
                        </CardBody>
                    </Card>
                    <Camera key={String("camera_" + index.id)} props={index} loadSell={loadSell} show={modalShow}
                        onHide={() => setModalShow(false)} />
                </GridItem >
            ) : <div></div>}
        </GridItem>
    );
}

export default TableDeliveryman;